﻿import React, { useState, useEffect } from 'react';
import GlobalDialog from '../Modal/GlobalDialog';
import { User } from '../../models/user';
import { DmaEvent } from '../../models/DmaEvents/dma-event';
import { DmaEventUser } from '../../models/DmaEvents/dma-event-user';
import { Notification } from '../../models/DmaEvents/notification';
import { EventType, EventStatusType } from '../../models/enums';
import { ModalMetadata } from '../../models/modal-metadata';
import { ModalMessageType } from '../../models/enums';
import { LookupItem } from '../../models/lookup-item';
import { ToastProps } from '../../models/toast-props';
import { CrudFunctions } from '../../utilities/crud-functions';
import { ItemBasicInformation } from '../../models/item-basic-information';
import ItemBasicInformationDialog from '../ItemBasicInformationDialog';
import DmaFooter from '../DmaFooter';

import DataGrid, {
    Column,
    FilterRow,
    Selection,
    Button as ColumnButton,
    HeaderFilter,
    Toolbar,
    Lookup,
    Item as ToolbarItem,
    Paging,
    Pager,
    Scrolling,
    SearchPanel,
    LoadPanel
} from 'devextreme-react/data-grid';

import Button from 'devextreme-react/button';
import { Popup as DialogPopup } from 'devextreme-react/popup';

let key = 0;

export default function EventsLogForm() {
    const [eventTypes, setEventTypes] =
        useState<LookupItem[]>();

    const [eventStatusTypes, setEventStatusTypes] =
        useState<LookupItem[]>();

    const [users, setUsers] =
        useState<User[]>();

    const [dmaEvents, setDmaEvents] =
        useState<DmaEvent[]>();

    const [selectedDmaEvent, setSelectedDmaEvent] =
        useState<DmaEvent>();

    const [dmaEventUsers, setDmaEventUsers] =
        useState<DmaEventUser[]>();

    const [notifications, setNotifications] =
        useState<Notification[]>();

    const [selectedNotification, setSelectedNotification] =
        useState<Notification>();

    const [itemBasicInformationDialogVisible, setItemBasicInformationDialogVisible] =
        useState<boolean>();

    const [itemBasicInformation, setItemBasicInformation] =
        useState<ItemBasicInformation>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    const [toastProps, setToastProps] =
        useState<ToastProps>();

    const [itemBasicInitInformation, setItemBasicInitInformation] =
        useState<ItemBasicInformation>();

    useEffect(() => {
        getAllData();
    }, []);

    useEffect(() => {
        getDmaEventUsers();
        getDmaEventNotifications();
    }, [selectedDmaEvent]);

    key++;

    return (
        <div className="pw-content">
            <div className="lq-title-bar pw-form-header">
                <div className="lq-main-title">DMA Events</div>

                <div className="title-bar-spacer" />
                <div className="save-toolbar">
                    <Button id="goBackButton" text="" icon="arrowleft" type="normal"
                        hint="go back"
                        height={'2.6em'}
                        onClick={goBack} />
                </div>
            </div>

            <div className="pw-margin-top-05">
                <DataGrid
                    height="16rem"
                    dataSource={dmaEvents ? dmaEvents : []}
                    wordWrapEnabled={true}
                    allowColumnResizing={true}
                    columnResizingMode='widget'
                    keyExpr="eventId"
                    onSelectionChanged={onDmaEventSelectionChanged}
                    rowAlternationEnabled={true}
                    showRowLines={true}
                    showBorders={true}>

                    <LoadPanel enabled={true} />
                    <Paging defaultPageSize={30} />
                    <Pager
                        showPageSizeSelector={true}
                        allowedPageSizes={[30, 60, 100]}
                        showInfo={true} />
                    <Selection mode='single' />
                    <HeaderFilter visible={true} />
                    <FilterRow visible={true} />

                    <SearchPanel visible={true} />

                    <Column type="buttons" width="6rem">
                        <ColumnButton hint="audit information" icon="clock"
                            onClick={onTaskAuditButtonClicked} />
                        <ColumnButton hint="information" icon="info"
                            onClick={onTaskInformationButtonClicked} />
                    </Column>

                    <Column dataField='eventNumber' caption="Event #" dataType='number' width='6rem' />

                    <Column dataField='eventType' caption="Event Type" dataType='number' width='10rem'>
                        <Lookup dataSource={eventTypes ? eventTypes : []}
                            displayExpr='name' valueExpr='id' />
                    </Column>

                    <Column dataField='eventStatus' dataType='number' width='10rem'>
                        <Lookup dataSource={eventStatusTypes ? eventStatusTypes : []}
                            allowClearing={false}
                            displayExpr='name' valueExpr='id' />
                    </Column>

                    <Column dataField='createTimestamp' format="MM/dd/yyyy hh:mm:ss" dataType='date' width='10rem' />
                    <Column dataField='payloadString' dataType='string' />

                    <Toolbar>
                        <ToolbarItem location='before'>
                            <div className="pw-datagrid-toolbar-template">
                                <div className="pw-datagrid-toobar-title">Event Log</div>
                            </div>
                        </ToolbarItem>

                        <ToolbarItem location='after' name="searchPanel" />
                    </Toolbar>


                </DataGrid>
            </div>

            {/*
            <div className="pw-margin-top-1">
                <NoteViewer height='8rem' title="Task Description" headerColor="pw-bg-blue"
                    noteType={NoteType.TaskDescription}
                    parentId={selectedTask && selectedTask.taskId ? selectedTask.taskId : null} />
            </div>
            */}

            {/*        
            <div>
                <TasksGanttComponent height={400} taskListWidth={500} />
            </div>
            */}

            <div className="pw-margin-top-05">
                <DataGrid
                    height="12rem"
                    dataSource={dmaEventUsers ? dmaEventUsers : []}
                    wordWrapEnabled={true}
                    allowColumnResizing={true}
                    columnResizingMode='widget'
                    keyExpr="userId"
                    rowAlternationEnabled={true}
                    showRowLines={true}
                    showBorders={true}>

                    <LoadPanel enabled={true} />
                    <Paging defaultPageSize={30} />
                    <Pager
                        showPageSizeSelector={true}
                        allowedPageSizes={[30, 60, 100]}
                        showInfo={true} />
                    <Selection mode='single' />
                    <HeaderFilter visible={true} />
                    <FilterRow visible={true} />

                    <SearchPanel visible={true} />

                    <Column type="buttons" width="6rem">
                        <ColumnButton hint="audit information" icon="clock"
                            onClick={onTaskAuditButtonClicked} />
                        <ColumnButton hint="information" icon="info"
                            onClick={onTaskInformationButtonClicked} />
                    </Column>

                    <Column dataField='monitorLevelId' caption="Monitor Level" dataType='number' width='6rem' />

                    <Column dataField='username' dataType='string' width='8rem' />
                    <Column dataField='lastName' dataType='string' width='8rem' />
                    <Column dataField='firstName' dataType='string' width='8rem' />
                    <Column />

                    <Toolbar>
                        <ToolbarItem location='before'>
                            <div className="pw-datagrid-toolbar-template">
                                <div className="pw-datagrid-toobar-title">Event Users</div>
                            </div>
                        </ToolbarItem>
                    </Toolbar>

                </DataGrid>
            </div>

            <div className="pw-margin-top-05">
                <DataGrid
                    height="16rem"
                    dataSource={notifications ? notifications : []}
                    wordWrapEnabled={true}
                    allowColumnResizing={true}
                    columnResizingMode='widget'
                    keyExpr="notificationId"
                    onSelectionChanged={onNotificationSelectionChanged}
                    rowAlternationEnabled={true}
                    showRowLines={true}
                    showBorders={true}>

                    <LoadPanel enabled={true} />
                    <Paging defaultPageSize={30} />
                    <Pager
                        showPageSizeSelector={true}
                        allowedPageSizes={[30, 60, 100]}
                        showInfo={true} />
                    <Selection mode='single' />
                    <HeaderFilter visible={true} />
                    <FilterRow visible={true} />

                    <SearchPanel visible={true} />

                    <Column type="buttons" width="6rem">
                        <ColumnButton hint="audit information" icon="clock"
                            onClick={onTaskAuditButtonClicked} />
                        <ColumnButton hint="information" icon="info"
                            onClick={onTaskInformationButtonClicked} />
                    </Column>

                    <Column dataField='notificationNumber' caption="Event #" dataType='number' width='6rem' />

                    <Column dataField='notificationStatus' caption="Status" dataType='number' width='10rem'>
                    </Column>

                    <Column dataField='createTimestamp' format="MM/dd/yyyy hh:mm:ss" dataType='date' width='10rem' />
                    <Column dataField='recipientsString' dataType='string' />

                    <Toolbar>
                        <ToolbarItem location='before'>
                            <div className="pw-datagrid-toolbar-template">
                                <div className="pw-datagrid-toobar-title">Event Notifications</div>
                            </div>
                        </ToolbarItem>

                        <ToolbarItem location='after' name="searchPanel" />
                    </Toolbar>
                </DataGrid>
            </div>

            <DmaFooter />

            {itemBasicInformationDialogVisible &&
                <DialogPopup visible={itemBasicInformationDialogVisible}
                    onHiding={hideItemBasicInformationDialog}
                    title="Item Basic Information"
                    width={'25rem'}
                    height={'21rem'}
                    dragEnabled={false}
                    resizeEnabled={false}>
                    <ItemBasicInformationDialog initInformation={itemBasicInitInformation}
                        onOkClick={hideItemBasicInformationDialog}
                        key={`IBI${key}`} />
                </DialogPopup>
            }

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} />
            }
        </div>
    );

    function onDmaEventSelectionChanged(e: any) {
        if (e.selectedRowsData && e.selectedRowsData.length > 0)
            setSelectedDmaEvent(e.selectedRowsData[0]);
    }

    function onNotificationSelectionChanged(e: any) {
        if (e.selectedRowsData && e.selectedRowsData.length > 0)
            setSelectedNotification(e.selectedRowsData[0]);
    }

    async function getEventTypes() {
        await CrudFunctions.getData("dmaevents/eventtypes")
            .then((data) => {
                setEventTypes(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Event Types");
            });
    }

    async function getEventStatusTypes() {
        await CrudFunctions.getData(`dmaevents/eventstatustypes`)
            .then((data) => {
                setEventStatusTypes(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Event Status Types");
            });
    }

    async function getAllUsers() {
        await CrudFunctions.getData("common/activeuserslist")
            .then((data) => {
                setUsers(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Active Users");
            });
    }

    async function getDmaEvents() {
        await CrudFunctions.getData("dmaevents/dmaevents")
            .then((data) => {
                setDmaEvents(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving DMA Events");
            });
    }

    async function getDmaEventUsers() {
        if (selectedDmaEvent && selectedDmaEvent.eventId) {
            await CrudFunctions.getData(`dmaevents/eventusers/${selectedDmaEvent.eventId}`)
                .then((data) => {
                    setDmaEventUsers(data);
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Retrieving DMA Event Users");
                });
        }
    }
    async function getDmaEventNotifications() {
        if (selectedDmaEvent && selectedDmaEvent.eventId) {
            await CrudFunctions.getData(`dmaevents/notifications/${selectedDmaEvent.eventId}`)
                .then((data) => {
                    setNotifications(data);
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Retrieving DMA Event Notifications");
                });
        }
    }

    async function getAllData() {
        await Promise.all([
            getAllUsers(),
            getEventTypes(),
            getEventStatusTypes(),
            getDmaEvents()
        ]);
    }

    //navigation
    function goBack() {
        history.back();
    }

    function onTaskAuditButtonClicked(e: any) {


    }


    //other
    function onTaskInformationButtonClicked(e: any) {

        console.log("onTaskInformationButtonClicked-----------------");
        console.log(e);

    }

    function hideTicketLogEntryDialog() {
        // setTicketLogEntryDialogVisible(false);
    }

    function hideItemBasicInformationDialog() {
        setItemBasicInformationDialogVisible(false);
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

    function clearGlobalDialog() {
        setGlobalDialogMetadata(null);
        setGlobalDialogVisible(false);
    }

    function showToast(message: string, toastType: string) {
        let toastParams: ToastProps = {
            message: message,
            toastType: toastType,
            visible: true
        };

        setToastProps(toastParams);
    }

    function onToastHiding() {
        let toastParams: ToastProps = {
            message: undefined,
            toastType: undefined,
            visible: false
        };

        setToastProps(toastParams);
    }
}
